export default __webpack_public_path__ + "static/media/image 123.bdcfcef7.png";